import { motion } from "framer-motion";
import { HeatBar } from "./HeatBar";
import { formatSim, heatColor, heatLabel } from "../lib/heat";
import type { GuessResult } from "@shared/types";

interface Props {
  guess: GuessResult;
  rank: number;
  isLatest: boolean;
}

export function GuessRow({ guess, rank, isLatest }: Props) {
  return (
    <motion.div
      layout
      initial={{ opacity: 0, y: -8, scale: 0.97 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      exit={{ opacity: 0, scale: 0.96 }}
      transition={{ type: "spring", stiffness: 220, damping: 24 }}
      className={`glass-soft rounded-xl px-4 py-3 ${
        isLatest ? "ring-1 ring-accent/60 shadow-glow" : ""
      }`}
    >
      <div className="flex items-baseline gap-3">
        <span className="font-mono text-xs text-ink-400 w-8 shrink-0">#{rank}</span>
        <span className="font-mono text-ink-100 truncate flex-1">{guess.text}</span>
        <span
          className="font-mono text-sm tabular-nums"
          style={{ color: heatColor(guess.similarity) }}
        >
          {formatSim(guess.similarity)}
        </span>
        <span className="text-xs text-ink-400 uppercase tracking-wider w-16 text-right hidden sm:inline">
          {heatLabel(guess.similarity)}
        </span>
      </div>
      <div className="mt-2">
        <HeatBar value={guess.similarity} pulse={guess.isWin} />
      </div>
    </motion.div>
  );
}
